const ToolDescription = ({ image, heading, description }) => {
  return (
    <div
  style={{
    borderStyle: "solid",
    border: "solid",
    borderWidth: "2px",
    borderRadius: "12px",
    borderColor: "#c0c0c0",
    width: "50%",
    height: "auto", // Adjust height to auto to accommodate content
    display: "flex",
    flexDirection: "column", // Change to column for vertical layout
    alignItems: "center", // Center-align items for a neat look
    padding: "20px",
  }}
>
  <div
    style={{
      width: "100%", // Ensure this div takes full width
      display: "flex",
      alignItems: "center",     // vertically center icon + heading
      justifyContent: "flex-start", // keep them together
      gap: "16px",               // spacing you choose
    }}
  >
    <img src={image} alt="tool" style={{ width: "50px", height: "auto"}} />
    <h4 style={{ margin: 0, textAlign: "left" }}>{heading}</h4>
  </div>
  <div
    style={{
      marginTop: "20px", // Add some space above the description
      width: "100%", // Ensure description takes full width
      textAlign: "left",
      fontSize: "14px",
      color: "#373737",
    }}
  >
    <p>{description}</p>
  </div>
</div>


  );
};

export default ToolDescription;
